import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CalendarView } from 'angular-calendar';

import { TranslationKeyMap } from '../../coaching-insight.i18n';

@Component({
    selector: '[cmpsCalendarNavigation]',
    templateUrl: './calendar-navigation.component.html',
    host: {
        'data-e2e': 'component-calendar-container',
    },
})
export class CalendarNavigationComponent {
    @Input() view: CalendarView;
    @Input() viewDate: Date;

    @Output() viewChange: EventEmitter<CalendarView>;
    @Output() viewDateChange: EventEmitter<Date>;

    /** @private */ _i18n = TranslationKeyMap;

    constructor() {
        this.viewChange = new EventEmitter();
        this.viewDateChange = new EventEmitter();
    }
}
